import React from 'react';

import wfLoader from 'assets/lotties/wf-loader-black.json';

import Loop from 'components/Loop';
import { Header } from 'libs/rendering/components/header';

import { DefaultSection } from 'styles/default';
import { LoadingBoxWrapper } from 'apps/home/landing/sections/fullScreenLoading.styles';

const FullScreenLoading = () => (
  <DefaultSection fullScreen>
    <Header />
    <LoadingBoxWrapper>
      <Loop lottieFile={wfLoader} />
    </LoadingBoxWrapper>
  </DefaultSection>
);

export default FullScreenLoading;
